export const logos = {
  agenda: './assets/logos/LogoAgenda.png',
  ammarhesBlue: './assets/logos/LogoAmmarhesBlue.png',
  ammarhesWrite: './assets/logos/LogoAmmarhesWrite.png',
  casaOcupacional: './assets/logos/LogoCasa.png',
  saude10: './assets/logos/LogoSaude10.png',
  ximed: './assets/logos/LogoXimed.png',
  ximedCompleto: './assets/logos/LogoXimedCompleto.png'
}
